export default function EditCandidateIco() {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_2895_188210)">
        <path
          d="M2.5 11C2.5 5.75329 6.75329 1.5 12 1.5H40C45.2467 1.5 49.5 5.75329 49.5 11V39C49.5 44.2467 45.2467 48.5 40 48.5H12C6.75329 48.5 2.5 44.2467 2.5 39V11Z"
          stroke="#EAECF0"
          shape-rendering="crispEdges"
        />
        <path
          d="M34 34C34 32.1362 34 31.2044 33.6955 30.4693C33.2895 29.4892 32.5108 28.7105 31.5307 28.3045C30.7956 28 29.8638 28 28 28H25C23.1362 28 22.2044 28 21.4693 28.3045C20.4892 28.7105 19.7105 29.4892 19.3045 30.4693C19 31.2044 19 32.1362 19 34M30.5 20C30.5 22.2091 28.7091 24 26.5 24C24.2909 24 22.5 22.2091 22.5 20C22.5 17.7909 24.2909 16 26.5 16C28.7091 16 30.5 17.7909 30.5 20Z"
          stroke="#344054"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2895_188210"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2895_188210"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2895_188210"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
